import React, { Component } from 'react';
import SelectableListCheckboxOption from 'components/SelectableListCheckboxOption';
import SelectableList from 'components/SelectableList';
import normalizeVariables from '../../../graphql/schema/normalizeVariables';

const loadOptions = (props) => {
  // Create map of selected id's and map of selected id to index in props.options
  const selectedMap = {};
  const deletedMap = {};
  if (props.value) {
    props.value.forEach((option, index) => {
      selectedMap[option.id] = true;
      if (option.selected === false || option.deleted) {
        selectedMap[option.id] = false;
      }
      deletedMap[option.id] = option.deleted;
    });
  }

  const options = [];
  if (props.data) {
    props.data.forEach((option, index) => {
      options.push({
        id: option.id,
        concurrencyVersion: option.concurrencyVersion,
        [props.optionLabelField]: option[props.optionLabelField],
        selected: selectedMap[option.id] ? selectedMap[option.id] : false,
        deleted: deletedMap[option.id],
        readOnly: typeof props.enabledField !== 'undefined' ? !option[props.enabledField] : false,
      });
    });
  }

  return options;
};

export default class SelectList extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    const originalOptions = loadOptions(props);
    const options = normalizeVariables(originalOptions, ['readOnly']);
    this.state = {
      value: props.value,
      data: props.value,
      originalOptions,
      options,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.value !== state.value || props.data !== state.data) {
      const originalOptions = loadOptions(props);
      const options = normalizeVariables(originalOptions, ['readOnly']);
      return {
        value: props.value,
        data: props.value,
        originalOptions: originalOptions,
        options: options,
      };
    }
    return null;
  }

  handleSelect(option) {
    const index = this.state.options.findIndex((element) => {
      return element.id === option.id;
    });
    const selected = !this.state.options[index].selected;
    const options = this.updateSelection(this.state.options, index, selected);
    this.props.onChange(options.filter((option) => option.selected || option.deleted));
  }

  updateSelection(options, idx, selected) {
    return options.map((item, index) => {
      if (index !== idx) {
        return item;
      }
      return {
        ...item,
        selected: selected,
        deleted: !selected,
      };
    });
  }

  render() {
    const outerListStyle = {
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderWidth: '1px',
    };

    const label = this.props.label ? (
      <label htmlFor={`${this.props.dataid}SelectList`}>{this.props.label}</label>
    ) : null;

    const empty = this.state.options.length === 0 ? <div>No options available</div> : null;
    return (
      <div>
        {label}
        <div id={`${this.props.dataid}SelectList`} style={outerListStyle}>
          {empty}
          <SelectableList
            options={this.state.originalOptions}
            optionClass={SelectableListCheckboxOption}
            onSelect={this.handleSelect}
            descriptionField={this.props.optionLabelField}
            showHighlight={false}
            dataid={this.props.dataid}
          />
        </div>
      </div>
    );
  }
}

SelectList.defaultProps = {
  descriptionField: 'description',
  defaultField: null,
  label: null,
};
